/**
 * リリースノート（DF Scanner・英語版）
 * @returns JSX.Element
 */
export const ReleaseNotesDfScannerEn = () => {
    return (
        <div>
            {/* Pro版 v1.9.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.9.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-28</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.9.2 has been released.</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue in Vector Merge where non-overlapping polygons could be unintentionally
                        reshaped.
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.9.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.9.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-07-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.9.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed the Analysis Area being ignored in some cases, causing the entire input to be processed
                        (Treetop Detection / Conifer Tree Segmentation / AI Crown Segmentation / Multilayer
                        Segmentation).
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.9.0, Lite版 v1.9.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.9.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.9.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-07-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.9.0 has been released.</p>
                    <p>DF Scanner Lite v1.9.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added a screenshot feature</p>
                    <p>・Added the ability to set the outline width of polygon layers from layer properties</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Area statistics: added more available statistical outputs</p>
                    <p>・Polygon editing: added the ability to create rectangular polygons</p>
                    <p>
                        ・Improved Geospatial Information Authority of Japan (GSI) DEM retrieval so that newer data than
                        before can be used
                    </p>
                    <p>
                        ・Changed the area calculation used in area/selected-area statistics to a geodesic method based
                        on an ellipsoidal (WGS84) model
                    </p>
                    <p>・Faster rendering of point data</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where the basemap and raster display settings were not saved by the
                        project-save feature
                    </p>
                    <p>・Fixed other minor bugs</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Improvements</p>
                    <p>・Fixed the behavior of multi-layer segmentation when no mask is specified</p>
                    <p>・Revised the post-processing of AI crown segmentation</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where output from the band stacking feature could appear misaligned</p>
                    <p>
                        ・Fixed an issue in the tree-fall risk assessment where an incorrect tree-height value was
                        output when a "+α" (additional length) value was set
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.8.1, Lite版 v1.8.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.8.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.8.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-22</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.8.1 has been released.</p>
                    <p>DF Scanner Lite v1.8.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue with incorrect DEM height acquisition in the Download DEM for Flight function
                        (available only for areas within Japan).
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.8.0, Lite版 v1.8.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.8.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.8.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.8.0 has been released.</p>
                    <p>DF Scanner Lite v1.8.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・DEM data acquisition for flight planning</p>
                    <p>・Raster data display settings</p>
                    <p>・Rendering settings for multiband data</p>
                    <br />
                    <p>UI Improvements</p>
                    <p>・Menu structure reorganization</p>
                    <p>・Line data display adjustment</p>
                    <br />
                    <p>Feature Improvements</p>
                    <p>・Update of the Hokkaido model</p>
                    <p>・Improved support for Windows security features</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>New Features</p>
                    <p>・Diversity Assessment function</p>
                    <p>・Treetop detection and crown segmentation by specified area</p>
                    <p>・Vector Merge function</p>
                    <p>・Raster Band Stacking function</p>
                    <br />
                    <p>Feature Improvements</p>
                    <p>・Revision of the default epoch count for My Species Identification AI</p>
                    <p>・Training history graph output for My Species Identification AI</p>
                    <p>・Multiband image support for My Species Identification AI</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fix for an issue where models created on PCs with a GPU could not be used on PCs without a GPU
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.7.1, Lite版 v1.7.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.7.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.7.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-03-06</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.7.1 has been released.</p>
                    <p>DF Scanner Lite v1.7.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Improvements</p>
                    <p>・Improved the masking function and treetop detection algorithm</p>
                    <p>・Improved vegetation map generation for datasets with gaps between tree crowns</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where masking could be incorrectly applied in treetop detection when using mask
                        images created from a different CHM
                    </p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where decimal values could not be specified in conditions in table calculations
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.7.0, Lite版 v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.7.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-01-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.7.0 has been released.</p>
                    <p>DF Scanner Lite v1.7.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Line data editing</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixes for other minor bugs</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>New Features</p>
                    <p>・Tree Fall Risk Assessment based on distance from roads and other features</p>
                    <p>・Quick Analyze for dead tree detection</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Update of the Japanese Species Identification model</p>
                    <p>・Automatic tree species selection based on region (Japanese Species Identification)</p>
                    <p>・Mask data specification in AI Crown Segmentation</p>
                    <p>・Update of models used for Unsupervised Classification</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.4, Lite版 v1.6.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.6.4</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.6.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-24</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.6.4 has been released.</p>
                    <p>DF Scanner Lite v1.6.4 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where, during DBH estimation, tree species were incorrectly treated as “Other
                        Broadleaf”, resulting in reduced estimation accuracy.
                    </p>
                    <p>
                        ・Fixed an issue where advanced treetop detection settings were not applied correctly for
                        extremely wide or tall datasets.
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.3, Lite版 v1.6.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.6.3</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.6.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.6.3 has been released.</p>
                    <p>DF Scanner Lite v1.6.3 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where login failed due to Windows Update.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.2, Lite版 v1.6.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.6.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.6.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-11-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.6.2 has been released.</p>
                    <p>DF Scanner Lite v1.6.2 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Improvements</p>
                    <p>・Added proxy support and optimization for base map display.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where Site Tuning did not speed up on subsequent runs.</p>
                    <p>
                        ・Fixed an error that occurred when saving a project containing files located on different
                        drives.
                    </p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Improvements</p>
                    <p>・Enhanced AI crown segmentation to support high-resolution data.</p>
                    <p>・Improved AI crown segmentation to prevent small holes in crowns.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where errors could occur during post-processing of AI crown segmentation.</p>
                    <p>
                        ・Fixed an issue where table calculations failed when the condition and output column were the
                        same.
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.1, Lite版 v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.6.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-10-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.6.1 has been released.</p>
                    <p>DF Scanner Lite v1.6.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Improvements</p>
                    <p>・Faster startup speed.</p>
                    <p>・Improved installer behavior</p>
                    <p>
                        ・Adjusted the ease of identification of other broadleaf trees in Quick Analyze tree species
                        classification
                    </p>
                    <p>・Improved tree species classification accuracy for high-resolution data</p>
                    <p>・CHM calculation optimization</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where multiple GeoTIFFs were not panned when imported at the same time.</p>
                    <p>・Fixed an issue where some GeoTIFF files were displayed in black.</p>
                    <p>・Fixed an issue where GeoTIFF import would fail in the English version.</p>
                    <p>・Fixed an issue where point editing would not save if multipoints and points were mixed.</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Improvements</p>
                    <p>・Improved accuracy of AI Crown Segmentation (beta version)</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the accuracy of My Model Training was reduced in offline environments.</p>
                    <p>・Fixed an issue where My Model Classification could fail</p>
                    <p>・Fixed the issue where Onetime Deep Learning failed.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.0, Lite版 v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.6.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-09-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.6.0 has been released.</p>
                    <p>DF Scanner Lite v1.6.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Function to assign field DBH data recorded with DF Walker to crown data</p>
                    <p>・Option to fix species display colors in user settings</p>
                    <p>・GPU environment diagnostics</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Improved behavior and rendering speed when loading GeoTIFF files</p>
                    <p>・Coniferous Tree Crown segmentation now works with or without an orthophoto image</p>
                    <p>
                        ・Accuracy improvements for Cryptomeria japonica (Sugi) / Chamaecyparis obtusa (Hinoki)
                        identification and Hokkaido conifer identification
                    </p>
                    <p>・Processing optimization in species identification</p>
                    <p>・Area clipping function now supports multiple polygon clipping regions</p>
                    <p>・Fixed distortion issues in images and other data at high latitudes</p>
                    <p>・Support for drawing lines, multilines, and multipoints</p>
                    <p>・Added DBH estimation models for Yezo spruce and Sakhalin spruce (Only for Japan)</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an error in height estimation when treetops existed outside the CHM range</p>
                    <p>・Fixed occasional failures in CHM calculation</p>
                    <p>・Fixed an issue where a black screen briefly appeared and froze at startup</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>New Features</p>
                    <p>・AI Crown Segmentation (Beta) – Broadleaved tree crown segmentation</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Unsupervised classification results revised to display as SP-1, SP-2, …</p>
                    <p>・Added threshold setting functionality in My Model Classification</p>
                    <p>・Default output now set to dead trees only when detecting dead trees</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an error in My Training Data Creation when the save destination had a deep folder
                        hierarchy
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.2, Lite版 v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.5.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-16</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.5.2 has been released.</p>
                    <p>DF Scanner Lite v1.5.2 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where automatic processing failed for data from Hokkaido, Aomori, Iwate, and
                        Miyagi.
                    </p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the accuracy of dead tree detection had temporarily decreased.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.1, Lite版 v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.5.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.5.1 has been released.</p>
                    <p>DF Scanner Lite v1.5.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Improvements</p>
                    <p>・Improved behavior of Pan/Zoom to feature from table</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where an error occurred when using the del key when editing polygons.</p>
                    <p>・Fixed an issue where the back operation did not work when editing polygons.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.0, Lite版 v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.5.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-03</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.5.0 has been released.</p>
                    <p>DF Scanner Lite v1.5.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Pan/Zoom to feature from table</p>
                    <p>・Distance and area calculation</p>
                    <p>
                        ・Automatic assignment of field species data created in DF Walker to different crown polygons
                        (Reference Species Assignment Function)
                    </p>
                    <br />
                    <p>Improvements</p>
                    <p>・Improved base map selection via icons</p>
                    <p>・Updated model for Sugi Hinoki identification</p>
                    <p>・Improved offline activation feature</p>
                    <p>・Improved default species selection for stem volume estimation / CO₂ stock calculation</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Added support for NVIDIA GeForce RTX 50 series</p>
                    <p>・Other minor bug fixes</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Improvements</p>
                    <p>・Table calculation now supports string input and logarithmic calculations</p>
                    <p>・Updated model for Hokkaido conifer species classification</p>
                    <br />
                    <p className="font-bold">■ Lite version only</p>
                    <p>New Features</p>
                    <p>・Conifer crown segmentation feature implemented (same as Pro version)</p>
                    <p>・Sugi Hinoki identification feature implemented (same as Pro version)</p>
                    <p>・Hokkaido species identification feature implemented (same as Pro version)</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.4.1, Lite版 v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.4.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-05-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.4.1 has been released.</p>
                    <p>DF Scanner Lite v1.4.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed a minor bug in Stem Volume Estimation.</p>
                    <p>・Fixed a minor bug in calculating CO2 Stock Estimation.</p>
                    <p>・Fixed an issue where the software did not close properly and updates failed.</p>
                    <p>
                        ・Bug fixes when importing zip format Geospatial Information Authority of Japan DEMs, and DEM1A
                        data support.
                    </p>
                    <br />
                    <p>Improvements</p>
                    <p>・Change default minimum area when finishing polygon editing.</p>
                    <p>・Changed the input file format for Crown-to-Treetop Conversion. (.crown.shp to .shp)</p>
                    <p>・Some English notations have been corrected.</p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed a minor bug when creating My Data.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.4.0, Lite版 v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.4.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.4.0 has been released.</p>
                    <p>DF Scanner Lite v1.4.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Crown-to-Treetop Conversion</p>
                    <p>・Treetop Editing</p>
                    <br />
                    <p>Improvements</p>
                    <p>・NASADEM data can now be used as DTM data for CHM calculation.</p>
                    <p>
                        ・Polygon editing has been improved to remove invalid polygons and apply other enhancements upon
                        completion.
                    </p>
                    <p>・The output format of Statistics Calculation has been refined.</p>
                    <p>・Data rendering speed has been improved.</p>
                    <p>
                        ・DBH calculation now automatically applies formulas tailored to Hokkaido (Japan) tree species.
                    </p>
                    <br />
                    <p className="font-bold">■ Pro version only</p>
                    <p>New Features</p>
                    <p>・Table Calculation</p>
                    <p>・Dead Tree Detection</p>
                    <p>・Hokkaido (Japan) Tree Species Identification (Beta)</p>
                    <br />
                    <p className="font-bold">■ Lite version only</p>
                    <p>Other</p>
                    <p>・Permanent licenses are now supported.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.2, Lite版 v1.3.2, v1.8.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-01-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.3.2 has been released.</p>
                    <p>DF Scanner Lite v1.3.2 has been released.</p>
                    <p>DF Scanner v1.8.2 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the results were not output correctly in Statistics Calculation.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.1, Lite版 v1.3.1, v1.8.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-12-23</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.3.1 has been released.</p>
                    <p>DF Scanner Lite v1.3.1 has been released.</p>
                    <p>DF Scanner v1.8.1 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a rare bug that occurred when pressing shortcut keys when editing polygons.</p>
                    <p>
                        ・Fixed an issue where DBH estimation formulas could not be deleted properly after being added.
                    </p>
                    <p>・Fixed an issue where some shapefiles could not be displayed.</p>
                    <p>・Fixed an issue where the inquiry dialog box was sometimes displayed incorrectly.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.0, Lite版 v1.3.0, v1.8.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.3.0 has been released.</p>
                    <p>DF Scanner Lite v1.3.0 has been released.</p>
                    <p>DF Scanner v1.8.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Added an unsupervised classification feature 【Pro】.</p>
                    <p>
                        ・Added the ability to calculate the relative spacing index in the statistics computation
                        feature for manually selected areas and the Calculate Statistics feature.
                    </p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Updated the AI model for Japanese Species Identification【Pro】.</p>
                    <p>
                        ・Improved the selection of the default region in Stem Volume Estimation to ensure it is more
                        appropriate.
                    </p>
                    <p>・Enhanced menu text and UI for better usability.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the CHM was not calculated correctly when using certain files.</p>
                    <p>
                        ・Resolved a rare issue where tree species were swapped during My Trainig Data Creation 【Pro】.
                    </p>
                    <p>・Fixed the behavior when reloading training data from columns during AI Training 【Pro】.</p>
                    <p>・Addressed an issue preventing certain shapefiles from being loaded.</p>
                    <br />
                    <p>Other Changes</p>
                    <p>・Changed the default adjustment method for CHM Adjustments from Slope to Vertical.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.1, Lite版 v1.2.1, v1.7.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.2.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.2.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.7.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.2.1 has been released.</p>
                    <p>DF Scanner Lite v1.2.1 has been released.</p>
                    <p>DF Scanner v1.7.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an error where tree species identification could fails when the orthoimage was smaller
                        than CHM.
                    </p>
                    <p>
                        ・Fixed an error that occurred when using data other than WGS84 when executing statistics
                        calculation.
                    </p>
                    <p>・Fixed an issue where an error could occur when importing orthoimages.</p>
                    <p>・Fixed behavior of CHM calculation when using Bigtiff.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.0, Lite版 v1.2.0, v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-08-23</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.2.0 has been released.</p>
                    <p>DF Scanner Lite v1.2.0 has been released.</p>
                    <p>DF Scanner v1.7.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Ground correction function updated.</p>
                    <p>・Updated sugi-hinoki classification model.</p>
                    <p>・Change from carbon stock estimation to CO2 stock estimation.</p>
                    <p>・Added Vegetation Map Creation function.</p>
                    <p>・Supports importing GeoJSON files.</p>
                    <p>・Supports display of donut-shaped polygons and multi-polygons.</p>
                    <p>・Supports multiple file import.</p>
                    <p>・Check polygon information with the Information button.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Improved performance of polygon display.</p>
                    <p>・Fix basemap display.</p>
                    <p>・Improved loading GeoTIFF files with overview.</p>
                    <p>・Improved selection statistics calculation.</p>
                    <p>・Partially improved the tree top detection algorithm.</p>
                    <br />
                    <p>Others</p>
                    <p>・Added DF account authentication when using online backup.</p>
                    <p>・Unified installer for GPU and CPU versions.</p>
                    <p>
                        ・Some of the text on the screen has been corrected and explanations of analysis parameters have
                        been added.
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.1.1, Lite版 v1.1.1, v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.1.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.1.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-06-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.1.1 has been released.</p>
                    <p>DF Scanner Lite v1.1.1 has been released.</p>
                    <p>DF Scanner v1.6.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where saving a project was not possible on first launch.</p>
                    <p>・Fixed an issue where polygons with empty geometry could be created when editing polygons.</p>
                    <p>
                        ・Fixed an issue where a column could not be added to the left of a newly created file when
                        editing polygons.
                    </p>
                    <p>・Fixed an issue where GeoTIFF files were not recognized when a tfw file was present.</p>
                    <p>Others</p>
                    <p>・The default installation location for the software has been changed.</p>
                    <br />
                    <br />
                </div>
            </div>

            {/* Pro版 v1.1.0, Lite版 v1.1.0, v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-05-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.1.0 has been released.</p>
                    <p>DF Scanner Lite v1.1.0 has been released.</p>
                    <p>DF Scanner v1.6.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added options for ground correction (vertical correction).</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Improved DBH estimation accuracy.</p>
                    <p>・Corrected to exclude non-vegetation in Statistics Calculation.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug where polygons were missing in Tree Crown Segmentation.</p>
                    <p>・Fixed a bug when editing polygons.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.2, Lite版 v1.0.2, v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.0.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.0.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-27</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.0.2 has been released.</p>
                    <p>DF Scanner Lite v1.0.2 has been released.</p>
                    <p>DF Scanner v1.5.2 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Function Improvements</p>
                    <p>・Improved tree top detection and tree crown segmentation process.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug when editing polygons.</p>
                    <p>
                        ・Fixed an issue where the minimum crown size parameter during multi-layer segmentation was not
                        working properly.
                    </p>
                    <p>・Fixed a bug in log file output.</p>
                    <br />
                    <p className="font-bold">■ For Lite v1.0.2</p>
                    <p>New Features</p>
                    <p>・Added size recalculation menu.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.1, Lite版 v1.0.1, v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-11</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.0.1 has been released.</p>
                    <p>DF Scanner Lite v1.0.1 has been released.</p>
                    <p>DF Scanner v1.5.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the tree species identification did not work.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.0, Lite版 v1.0.0, v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-07</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro v1.0.0 has been released.</p>
                    <p>DF Scanner Lite v1.0.0 has been released.</p>
                    <p>DF Scanner v1.5.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added fully automatic analysis function.</p>
                    <p>・Added area clipping function.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・The sugi hinoki identification model has been improved.</p>
                    <p>・Modified to delete unnecessary cache when starting the software.</p>
                    <br />
                    <p className="font-bold">■ For Pro v1.0.0, DF Scanner v1.5.0</p>
                    <p>Function Improvements</p>
                    <p>・Modified to allow DBH estimation even when there is no tree species information.</p>
                    <p>・Corrected to recalculate tree crown area when estimating DBH.</p>
                    <p>・Some improvements have been made to the polygon creation function.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where columns were not referenced when creating My Model.</p>
                    <p>・Fixed an issue where the image would shift when cropping in My Model Creation.</p>
                    <br />
                </div>
            </div>

            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-02-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.4.1 has been released.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・The thickness of polygon lines now automatically changes during zooming and scaling.</p>
                    <p>・The point size now automatically changes during zooming and scaling.</p>
                    <p>・Added shortcut keys for polygon editing (add, delete, merge, split, remove).</p>
                    <p>・Enabled movement by pressing the wheel during polygon editing.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where errors occur when calculating selection statistics.</p>
                    <p>
                        ・Fixed a problem where column names would change to "Species_x, Species_y" when analyzing the
                        same file twice with sitetuning or Onetime Deeplearning.
                    </p>
                    <p>・Fixed an error that occurs when reassigning the "polygonID" column during table editing.</p>
                    <p>
                        ・Corrected an issue where the number of vertices would decrease when small polygons are loaded.
                    </p>
                    <p>・Fixed a problem where new shapefiles would not display when toggling visibility on/off.</p>
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-01-24</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.4.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・It is now possible to edit the table when editing polygon data.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where "Statistical Calculation" is conducted.</p>
                    <p>
                        ・Fixed a problem that stopped calculations when generating mask images if the CRS of ortho
                        images and CHM data were different.
                    </p>
                    <p>
                        ・Fixed an issue where tree apex detection would not work when the smoothing option for CHM is
                        unchecked.
                    </p>
                    <p>・Changed the encoding of shapefiles outputted by multi-layer segmentation to Shift_JIS.</p>
                    <p>・Fixed a problem where CHM calculation would stop for large-sized files.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Accelerated the process of coniferous tree crown separation.</p>
                    <p>・Accelerated the tree species identification process.</p>
                    <p>・Speeded up the rendering process for large GeoTIFF files.</p>
                </div>
            </div>

            {/* v1.3.3*/}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.3 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue with the functionality of being able to log in for 7 days offline.</p>
                </div>
            </div>

            {/* v1.3.2*/}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.2 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue with Onetime Deeplearning not working.</p>
                    <p>・Fixed an issue with the project save functionality not working in the commercial version.</p>
                    <p>・Adjusted behavior during masking for data that is not operational.</p>
                </div>
            </div>

            {/* v1.3.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.1 has been released.</p>
                    <br />
                    <p>DF Scanner v1.3.1 includes the following additional features:</p>
                    <p>- Polygon editing capabilities (addition, deletion, splitting, merging)</p>
                    <p>
                        - Forest compartment statistics calculation (corresponding to crown polygons and tree vertices)
                    </p>
                    <p>- Mask image creation function compatible with CHM created from LiDAR data</p>
                    <p>- Tree height calculation function for tree vertices</p>
                    <br />
                    <p>Additionally, the following items have been improved:</p>
                    <p>Acceleration of coniferous tree crown separation function</p>
                    <p>Acceleration of polygon tree height calculation function</p>
                    <br />
                    <p>Furthermore, documentation has been added, including:</p>
                    <p>Manual updates</p>
                    <p>Addition of purpose-specific procedural explanations</p>
                    <p>Simple manual in PDF format</p>
                    <p>YouTube link explaining analysis methods</p>
                    <p>Supplement to the privacy policy</p>
                    <br />
                    <p>We have also addressed minor issues.</p>
                    <br />
                    <p>Additionally, starting from this release, we now support credit card payments online.</p>
                    <p>For more details, please check our DF WebService page.</p>
                </div>
            </div>

            {/* v1.2.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.2.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-10-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Feature Improvements</p>
                    <p>・Updated the tree species identification model.</p>
                    <p>・Simplified some of the confusing UI elements.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Addressed issues with loading certain data.</p>
                    <p>・Fixed other minor issues.</p>
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-04-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Additional Features</p>
                    <p>・Implemented project save functionality.</p>
                    <p>・Implemented online backup functionality for project data.</p>
                    <p>・Implemented "Multi-Layer Segmentation" feature for deciduous tree crown separation.</p>
                    <p>
                        ・Implemented the ability to use National Land Information Division (GSI) DEM data online during
                        CHM calculation.
                    </p>
                    <p>・Added support for drawing and analyzing coordinate reference system data other than WGS84.</p>
                    <p>・Updated the tree species identification model.</p>
                    <p>・Implemented unsupervised classification of tree species.</p>
                    <p>・Implemented the functionality to create DBH estimation equations from on-site data.</p>
                    <p>・Enabled transparent rendering of shapefiles.</p>
                    <p>・Performed English localization for all tools.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where drawing of certain orthoimages failed.</p>
                    <p>・Fixed an issue where coniferous tree crown separation did not work for some data.</p>
                    <p>
                        ・Fixed an issue where the coordinate reference system conversion function was not available for
                        some data.
                    </p>
                    <br />
                    <p>Other</p>
                    <p>・Updated the terms of service.</p>
                    <p>・Updated the manual.</p>
                    <p>・Released an English version of the manual.</p>
                    <p>・Made the installer multilingual.</p>
                </div>
            </div>

            {/* v1.1.6 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.6</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-11-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Bug Fixes</p>
                    <p>・Resolved the issue where DF Scanner would not launch when newly installed.</p>
                </div>
            </div>

            {/* v1.1.5 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.5</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-11-17</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Additional Features</p>
                    <p>・Added English language support.</p>
                    <p>・Improved the tree species identification accuracy for deciduous trees.</p>
                    <p>・Added the ability to import analysis results after analysis.</p>
                    <p>・Increased the calculation speed for coniferous tree crown separation.</p>
                    <p>・Introduced a new crown separation program.</p>
                    <p>・Enhanced drawing speed for TIFF files, especially from the second time onward.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed the issue where the program would not launch after updating.</p>
                    <p>・Resolved the problem where analysis could not be performed on large-sized data.</p>
                    <p>・Implemented other minor fixes.</p>
                    <br />
                    <p>Other</p>
                    <p>・Updated the manual.</p>
                </div>
            </div>

            {/* v1.1.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-09-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Additional Features</p>
                    <p>・Added coordinate reference system conversion functionality.</p>
                    <p>・Introduced the capability to retrieve raster values.</p>
                    <p>・Added the ability to import analysis results after analysis.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug in the calculation formula of the timber volume calculation program.</p>
                    <p>
                        ・Resolved an issue where the calculation was not performed correctly during CHM calculation
                        when some DEM values were missing.
                    </p>
                    <br />
                    <p>Implemented other minor fixes.</p>
                    <p>Updated the manual.</p>
                </div>
            </div>

            {/* v1.1.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-09-20</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug in the calculation formula of the timber volume calculation program.</p>
                </div>
            </div>

            {/* v1.1.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Bug Fixes</p>
                    <p>・Fixed the issue where the program would not launch on some PCs.</p>
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Additional Features</p>
                    <p>・Added functionality for estimating carbon accumulation.</p>
                    <p>・Implemented deactivation functionality.</p>
                    <p>
                        ・Added area, density, volume per unit area of timber, and carbon accumulation to statistical
                        information.
                    </p>
                    <br />
                    <p>Accuracy and Functionality Improvements</p>
                    <p>・Improved the identification model for Japanese cedar (Sugi) and cypress (Hinoki).</p>
                    <p>・Increased the speed of image extraction during tree species identification.</p>
                    <p>・Updated the timber volume estimation functionality.</p>
                    <p>・Enhanced the speed of timber volume estimation.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug where the splash screen appeared during analysis.</p>
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-07-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Released DF Scanner v1.0.0.</p>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfScannerEn;
